/** other's industry membership numbers, printed on every supplier PO
 *  (Stephanie 2026-10-27). Given by Stephanie — change here if they change. */
export const OTHER_ASI_NUMBER = "301351";
export const OTHER_AIM_NUMBER = "90640";
